import { gql } from "@outschool/ui-apollo";

import { ParentFragment } from "./ParentFragments";
import TimetableFragment from "./TimetableFragment";

export default gql`
  fragment ClassScheduleRequestFragment on ClassScheduleRequest {
    uid
    parent {
      ...ParentFragment
    }
    timetable {
      ...TimetableFragment
    }
    timeZone
    message
    created_at
    parentEnrolledAt
  }
  ${ParentFragment}
  ${TimetableFragment}
`;
